export const listenToCustomEvent = (eventName, listener, target = window.document) => {
    const eventListener = (evt) => {
        listener(evt);
    };
    target.addEventListener(eventName, eventListener);
    return () => target.removeEventListener(eventName, eventListener);
};
//# sourceMappingURL=listenToCustomEvent.js.map